/**
 *
 * This loader will rotate the image
 * passed here.
 *
 * you can change it as you needed.
 *
 */

import React from 'react';
import { Spinner } from 'react-bootstrap';

interface ILoader {
  animation?: "border" | "grow",
  role?: string,
  innerClassName?: string,
  loaderText?: string,
}

const Loader = ({
  animation="border",
  role="status",
  innerClassName="visually-hidden",
  loaderText=""
  }:ILoader) => { 

  return (
    <Spinner animation={animation} role={role}>
      <span className={innerClassName}>{loaderText}</span>
    </Spinner>
  );
};

export default Loader;
